export class HTMLHelper {
  public static isDescendant(parent: HTMLElement, child: HTMLElement): boolean {
    let node = child.parentElement;
    while (node) {
      if (node == parent) {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  public static isElementInViewport(element: Element): boolean {
    if (!element) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  public static removeAllChildNodes(parent: Element): void {
    while (parent?.firstChild) {
      parent?.removeChild(parent?.firstChild);
    }
  }

  public static getElementPositionOnScreen(element: Element): ElementOffset {
    const elementRect = element.getBoundingClientRect();
    const bodyRect = document?.querySelector('body')?.getBoundingClientRect();

    if (!bodyRect) {
      return new ElementOffset();
    }

    return {
      top: elementRect.top - bodyRect.top,
      bottom: elementRect.bottom - bodyRect.bottom,
      left: elementRect.left - bodyRect.left,
      right: elementRect.right - bodyRect.right,
    };
  }
}

class ElementOffset {
  public top: number = 0;
  public bottom: number = 0;
  public left: number = 0;
  public right: number = 0;
}
